var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex"},[(
      _vm.$hasPermission({
        context: 'FAILURE_TRACKING_MANAGEMENT|EXPORT',
        action: 'read',
      })
    )?_c('v-btn',{staticClass:"primary my-btn tw-px-3 tw-py-2 tw-mr-2",attrs:{"rounded":""},on:{"click":function($event){$event.preventDefault();return _vm.onExport()}}},[_vm._v(" "+_vm._s(_vm.$t("button.exportExcel"))+" ")]):_vm._e(),(
      _vm.$hasPermission({
        context: 'FAILURE_TRACKING_MANAGEMENT',
        action: 'create',
      })
    )?_c('v-btn',{staticClass:"primary my-btn tw-px-3 tw-py-2 tw-mr-2",attrs:{"rounded":""},on:{"click":function($event){$event.preventDefault();return _vm.getRouteAddFailureTracking()}}},[_vm._v(" "+_vm._s(_vm.$t("button.addFailure"))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }